import { Route } from 'react-router-dom';
import loadable from 'utils/loadable';
// import Register from '../../pages/Register';

export const PUBLIC_ROUTES = [
  {
    path: '/retaillogin',
    component: loadable(import('pages/Login')),
    exact: true,
  },
  {
    path: '/tmlogin',
    component: loadable(import('pages/TMLogin')),
    exact: true,
  },
  {
    path: '/forgot-password',
    component: loadable(import('pages/ForgotPassword')),
    exact: true,
  },
  {
    path: '/reset-password/',
    component: loadable(import('pages/ResetPassword')),
    exact: true,
  },
  { path: '/faq', component: loadable(import('pages/FAQPage')), exact: true },
];

const publicRoutes = () =>
  PUBLIC_ROUTES.map((route) => <Route {...route} key={route.path} />);

export default publicRoutes;
